import axios from "axios";

const { REACT_APP_BACKEND_BASE_URL } = process.env;

export function getURL() {
    return {
        backendUrl: REACT_APP_BACKEND_BASE_URL,
    };
}

class AcumaAPIException extends Error {
    constructor(message, statusCode) {
        super(message);
        this.name = "AcumaAPIException";
        this.statusCode = statusCode;
    }
}

const acumaAxios = axios.create({
    timeout: 90000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
    }, // !! Axios not sending this by default??!! Needed for a SPA
});

export function validateToken(cb) {
    //console.log("In validateToken...");
    Promise.resolve()
        .then(() => {
            return acumaAxios({
                url: "/validate/apicall",
                method: "POST",
                headers: { "X-Requested-With": "XMLHttpRequest" },
                validateStatus: (status) => {
                    return true;
                },
            });
        })
        .then((res) => {
            if (res.data.isValid) {
                cb(null);
                /*return new Promise((resolve) => {
                    resolve({ data: { isValid: true } });
                });*/
            } else {
                cb(new Error("Not valid"));
                /*return acumaAxios({
                    url: "/refresh",
                    method: "POST",
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                    validateStatus: (status) => {
                        return true;
                    },
                });*/
            }
        })
        .catch((e) => {
            console.log("Error while validating the token: ", e);
            cb(e);
        });
    /*.then((res) => {
            if (res.data.isValid) {
                cb();
            }
        });*/
}

export function callApi(endpoint, data, method, headers = {}) {
    //console.log("Now calling API...");
    let opts = {
        url: endpoint,
        method: method || "POST",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            ...headers, // Spread any additional headers, like Authorization
        }, // !! Axios not sending this by default??!! Needed for a SPA
        validateStatus: (status) => {
            return true; // we will handle all failures
        },
    };
    if (data.params) opts.data = data.params;
    else opts.data = data;

    /*if (needAuthorization) {
    console.log(
      "store.getState().appstate.jwtToken: " +
        store.getState().appstate.jwtToken
    );
    opts.headers.Authorization = `Bearer ${store.getState().appstate.jwtToken}`;
  }*/

    return acumaAxios(opts)
        .then((res) => {
            if (res.status >= 400) {
                throw new AcumaAPIException(res?.data?.message, res.status);
            }
            return res;
            /*if (res.status === 200) {
            if (!res.data) {
                throw new Error("No data found for request");
            } else {
                if (res.data.status === "session-timeout") {
                    throw new Error("Your session has expired!");
                } else {
                    //console.log('RES', ep, res.data)
                    return res.data;
                }
            }
        } else if (res.status === 440) {
          
        } else {
            throw new Error(
                "This data is currently unavailable. For more details please contact our support team."
            );
        }*/
        })
        .catch((e) => {
            console.log(e);
            throw e;
        });
}

export const colorMaps = {
    diary: {
        bleeds: "#C90000",
        visits: "#5F79E3",
        symptoms: "#BBA23A",
    },
    diaryDetails: {
        bleeds: "#C90000",
        help: "#C90000",
        visits: "#5F79E3",
        reminders: "#1070B5",
        symptoms: "#BBA23A",
        weightlogs: "#5F79E3",
        inhibitorStatus: "#C90000",
        treatmentLogs: "#C90000",
    },
};
